import React, { createContext, useContext, useState, ReactNode } from "react";
import { z } from "zod";
import { UseFormReturn } from "react-hook-form";

// Form validation schema
export const registrationSchema = z.object({
  firstName: z.string().min(2, "First name is required"),
  lastName: z.string().min(2, "Last name is required"),
  // email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  ticketType: z.string().min(0, "Please select a ticket type"),
  quantity: z.coerce.number().min(1, "Quantity must be at least 1"),
  // company: z.string().min(2, "Company name is required"),
  // jobTitle: z.string().min(2, "Job title is required"),
  // dietary: z.string().optional(),
  // questions: z.string().optional(),
  marketingConsent: z.boolean().optional(),
  agreeTerms: z.boolean().refine((val) => val === true, {
    message: "You must agree to the terms and conditions",
  }),
  email: z.array(
    z.string().email("One or more recipients are not valid emails")
  ),
  // .nonempty("At least one recipient is required"),

  // agreeTerms: z.boolean().refine((val) => val === true, {
  //   message: "You must agree to the terms and conditions",
  // }),
});

export type RegistrationFormValues = z.infer<typeof registrationSchema>;

interface RegistrationContextType {
  step: number;
  setStep: (step: number) => void;
  isPaymentProcessing: boolean;
  setIsPaymentProcessing: (isProcessing: boolean) => void;
  showOrderSummary: boolean;
  setShowOrderSummary: (show: boolean) => void;
  form?: UseFormReturn<RegistrationFormValues>;
  setForm: (form: UseFormReturn<RegistrationFormValues>) => void;
}

const RegistrationContext = createContext<RegistrationContextType | undefined>(
  undefined
);

export const RegistrationProvider: React.FC<{
  children: ReactNode;
  initialStep?: number;
  initialShowOrderSummary?: boolean;
}> = ({ children, initialStep = 1, initialShowOrderSummary = false }) => {
  const [step, setStep] = useState(initialStep);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const [showOrderSummary, setShowOrderSummary] = useState(
    initialShowOrderSummary
  );
  const [form, setForm] = useState<UseFormReturn<RegistrationFormValues>>();

  return (
    <RegistrationContext.Provider
      value={{
        step,
        setStep,
        isPaymentProcessing,
        setIsPaymentProcessing,
        showOrderSummary,
        setShowOrderSummary,
        form,
        setForm,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
};

export const useRegistration = () => {
  const context = useContext(RegistrationContext);
  if (context === undefined) {
    throw new Error(
      "useRegistration must be used within a RegistrationProvider"
    );
  }
  return context;
};
